import { useRef, useState } from 'react';
// Derives the verify URL from the current (already prefix-correct) gate URL by
// swapping the `/view` segment for `/verify-password`, preserving the token in
// the query. On success the server has set the verification cookie, so a reload
// renders the invoice.
const verifyUrlFromLocation = () => {
    const { pathname, search } = window.location;
    return `${pathname.replace(/\/view$/, '/verify-password')}${search}`;
};
export const useVerifyPassword = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const inFlight = useRef(false);
    const clearError = () => setError(null);
    const verify = async (password) => {
        if (!password || inFlight.current) {
            return;
        }
        inFlight.current = true;
        setLoading(true);
        setError(null);
        try {
            const res = await fetch(verifyUrlFromLocation(), {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ password }),
            });
            if (res.ok) {
                window.location.reload();
                return;
            }
            if (res.status === 401) {
                setError('INVALID_PASSWORD');
            }
            else if (res.status === 429) {
                setError('TOO_MANY_ATTEMPTS');
            }
            else {
                setError('UNKNOWN');
            }
        }
        catch {
            setError('UNKNOWN');
        }
        setLoading(false);
        inFlight.current = false;
    };
    return { loading, error, verify, clearError };
};
//# sourceMappingURL=useVerifyPassword.js.map